import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { Toaster } from "@/components/ui/sonner";
import RequesterLogin from "@/pages/RequesterLogin";
import RequesterPortal from "@/pages/RequesterPortal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function RequireRole({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Carregando...</div>;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/"} replace />;
  if (user.role !== role) return <Navigate to={role === "admin" ? "/admin/login" : "/"} replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BrandingProvider>
          <Routes>
            <Route path="/" element={<RequesterLogin />} />
            <Route path="/portal" element={<RequireRole role="solicitante"><RequesterPortal /></RequireRole>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireRole role="admin"><AdminDashboard /></RequireRole>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrandingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
